// extracted by mini-css-extract-plugin
export default {"description":"Description_description__khN-Z"};